import $ from 'jquery';

$(document).ready(function() {
    // $(window).resize(function () {
    //     if (window.matchMedia("(max-width: 1024px)").matches) {
    //         $('.mob-menu.--mobile').on('click',function () {
    //             $('.header__mobile-nav').fadeToggle(300).addClass('--active');
    //             if ($('.header__dropdown').hasClass('--open')) {
    //                 $('.header__dropdown').removeClass('--open');
    //                 $('.dropdown-menu-header').slideToggle(300);
    //             }
    //         });
    //
    //         $('.header__mobile-nav-wrapper .close img').on('click',function () {
    //             if($('.header__mobile-nav').hasClass('--active')) {
    //                 $('.header__mobile-nav').removeClass('--active');
    //             }
    //         });
    //     }
    // });

    if (window.matchMedia("(max-width: 1024px)").matches) {
        $('.mob-menu.--mobile').on('click',function () {
            $('.header__mobile-nav').fadeToggle(300);
            if ($('.header__dropdown').hasClass('--open')) {
                $('.header__dropdown').removeClass('--open');
                $('.dropdown-menu-header').slideToggle(300);
            }
        });

        $('body').on('click',function (e) {
           if((e.target.className == 'header__list') || (e.target.className == 'mob-menu__img') || (e.target.className == 'header__list-item') ){
                return false;
           } else {
               $('.header__mobile-nav').fadeOut(300);
           }
        });
    }

    const dropdownList = $('.dropdown-menu-header a');

    $('.header__dropdown').on('click',function (event) {
        if ($(this).hasClass('--open')) {
            $(this).removeClass('--open');
            $('.dropdown-menu-header').slideToggle(300);
            event.stopPropagation();
        } else {
            $('.dropdown-menu-header').slideToggle(300);
            $(this).addClass('--open');
            if ($('.header__mobile-nav').css('display') == 'block') {
                $('.header__mobile-nav').fadeToggle(300);
            }
            event.stopPropagation();
        }
    });

    $(document).on('click', function() {
        if ($('.header__dropdown').hasClass('--open')) {
            $('.header__dropdown').removeClass('--open');
            $('.dropdown-menu-header').slideToggle(300);
        }
    });

    dropdownList.on('click',function () {
        $('.header__dropdown-inner .active').text($(this).text());
    });
});

if (window.matchMedia("(min-width: 1024px)").matches) {
    $( ".header__list-item-desktop" ).each(function () {
        $( ".header__list-item-desktop" ).hover(
            function (){
                $( ".header__list-item-desktop" ).removeClass('active');
            },
            function (){
                $('.header__list-item-desktop[data-active="active"]').addClass('active');
            }
        )
    });
}